<template>
  <div>
    <iframe
      id="showcase"
      :src="`/bundle/showcase.html?m=i9cMAR7j7wS&play=1&applicationKey=${appKey}`"
      width="800px"
      height="600px"
      frameborder="”0”"
      allow="xr-spatial-tracking"
      allowfullscreen
      @load="connectSDK"
      @click="onClickMap"
    >
    </iframe>
    <br />
    <div style="display: flex; gap: 5px; flex-direction: column">
      <div style="display: flex; gap: 5px">
        <b-button @click="getApp"> APP </b-button>
        <div>
          <b-button @click="getCamera"> camera </b-button>
          <b-button @click="pan"> pan </b-button>
          <b-button @click="resetZoom"> reset zoom </b-button>

          <div>
            <b-button @click="moveInDirection('FORWARD')"> forward </b-button>
            <b-button @click="moveInDirection('BACK')"> back </b-button>
            <b-button @click="moveInDirection('UP')"> up </b-button>
            <b-button @click="moveInDirection('DOWN')"> down </b-button>
            <b-button @click="moveInDirection('RIGHT')"> right </b-button>
            <b-button @click="moveInDirection('LEFT')"> left </b-button>
          </div>
        </div>
        <b-button @click="getSetting"> getSetting </b-button>
        <b-button @click="getMode"> Mode </b-button>
        <div style="display: flex; gap: 5px; flex-direction: column">
          <b-button @click="worldToScreen"> worldToScreen </b-button>
          <b-button @click="getCameraPose"> subcameraPose </b-button>
        </div>
        <div>
          <b-button @click="getLabel"> getLabel </b-button>
          <!-- <b-button @click="subLabel"> subLabel </b-button> -->
        </div>
      </div>
      <div style="display: flex; gap: 5px">
        <!-- <b-button @click="createAStarRunner"> createAStarRunner </b-button> -->
        <div style="display: flex; gap: 5px; flex-direction: column">
          <b-button @click="createDeepLink"> createDeepLink </b-button>
          <b-button @click="createLink"> createLink </b-button>
          <b-button @click="setExternalLinkPolicy">
            setExternalLinkPolicy
          </b-button>
        </div>
        <div style="display: flex; gap: 5px; flex-direction: column">
          <b-button @click="addObj"> add tag </b-button>
          <div>
            <b-form-select
              v-model="selected_Billboard"
              :options="list_point"
              value-field="sid"
              text-field="label"
            ></b-form-select>
            <b-form-input
              v-model="label"
              placeholder="Enter your label"
            ></b-form-input>
            <b-form-input
              v-model="description"
              placeholder="Enter your description"
            ></b-form-input>

            <b-button @click="editBillboard"> editBillboard </b-button>
            <b-form-input
              v-model="color"
              :id="`type-color`"
              :type="'color'"
            ></b-form-input>
            <b-button @click="editColor"> editColor </b-button>
          </div>
          <b-button @click="removeObj"> remove tag </b-button>
        </div>
      </div>
    </div>
    <br />
    <div>
      list point
      <ul>
        <li v-for="item in list_point" :key="item" @click="gotoPoint(item)">
          <pre>{{ item.label }}</pre>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import MpSdk from "../../../../bundle/sdk";

export default {
  data() {
    return {
      appKey: "kakqkp53m3qgsh83wtdcaenab",
      token: "9dfd6f5055370db4",
      sdk: null,
      list_point: [],
      new_tag: [],
      cameraPose: {},
      selected_Billboard: null,
      description: "",
      label: "",
      color: "#000000",
    };
  },
  async created() {},
  async mounted() {},
  methods: {
    async connectSDK(e) {
      // console.log(e);
      const showcase = document.getElementById("showcase");
      // console.log(showcase);
      // let sdk;
      try {
        const showcaseWindow = showcase.contentWindow;
        console.log("showcaseWindow", showcaseWindow);
        // console.log(showcaseWindow.MP_SDK);
        this.sdk = await showcaseWindow.MP_SDK.connect(showcaseWindow, {
          applicationKey: this.appKey,
        });
        // console.log(this.sdk);
        // console.log(showcaseWindow.MP_SDK);
        this.onShowcaseConnect(this.sdk);
        this.getListPoint();
        // this.getCameraPose()
      } catch (e) {
        console.error(e);
        return;
      }

      console.log("Hello Bundle SDK", this.sdk);
    },
    onShowcaseConnect(sdk) {
      sdk.App.state.subscribe((state) => {
        console.log("appState", state);
      });
    },
    async addObj() {
      // console.log("GO UP");
      //   this.sdk.Camera.moveInDirection(this.sdk.Camera.Direction.FORWARD)
      //   console.log( this.sdk.Mattertag.data);
      // add tag
      console.log(this.sdk.Mattertag);
      this.new_tag = await this.sdk.Mattertag.add([
        {
          label: "New tag",
          description: "This tag was added through the Matterport SDK",
          anchorPosition: {
            x: 0,
            y: 0,
            z: 0,
          },
          stemVector: {
            // make the Mattertag stick straight up and make it 0.30 meters (~1 foot) tall
            x: 0,
            y: 0.3,
            z: 0,
          },
          color: {
            // blue disc
            r: 0.0,
            g: 0.0,
            b: 1.0,
          },
          floorIndex: 0, // optional, if not specified the sdk will provide an estimate of the floor index for the anchor position provided.
        },
      ]);
      console.log(this.new_tag);
    },
    async removeObj() {
      // remove tag by sid
      let res = await this.sdk.Mattertag.remove(this.new_tag);
      console.log(res);
    },
    async getSetting() {
      let res = await this.sdk.Settings.get("mattertag");
      console.log("setting: ", res);
    },
    async getListPoint() {
      let list = await this.sdk.Mattertag.getData();
      // console.table(list);
      this.list_point = [];
      for (let i = 0; i < list.length; i++) {
        const el = list[i];
        this.list_point.push(el);
      }
    },
    async getApp() {
      let App = await this.sdk.App;
      console.log("App : ", App);

      let getLoadTimes = await this.sdk.App.getLoadTimes();
      console.log("getLoadTimes : ", getLoadTimes);

      let getState = await this.sdk.App.getState();
      console.log("getState : ", getState);
    },
    async getCamera() {
      let Camera = await this.sdk.Camera;
      console.log("Camera : ", Camera);

      let getPose = await this.sdk.Camera.getPose();
      console.log("getPose : ", getPose);
    },
    async moveInDirection(Direction) {
      const nextDirection = this.sdk.Camera.Direction[Direction];
      await this.sdk.Camera.moveInDirection(nextDirection);
    },
    async pan() {
      await this.sdk.Camera.pan({ x: 0, z: 0 });
    },
    async resetZoom() {
      await this.sdk.Camera.zoomReset();
    },
    async worldToScreen() {
      let showcase = document.getElementById("showcase");
      let showcaseSize = {
        w: showcase.clientWidth,
        h: showcase.clientHeight,
      };
      let cameraPose = this.cameraPose; // get pose using: mpSdk.Camera.pose.subscribe
      let mattertag = await this.sdk.Mattertag.getData(); // get a mattertag from the collection using: mpSdk.Mattertag.getData
      console.log(cameraPose, mattertag);
      let screenCoordinate = this.sdk.Conversion.worldToScreen(
        mattertag[0].anchorPosition,
        cameraPose,
        showcaseSize
      );
      console.log(screenCoordinate);
    },
    async getCameraPose() {
      let pose_;
      let vm = this;
      this.sdk.Camera.pose.subscribe(function (pose) {
        // Changes to the Camera pose have occurred.
        pose_ = pose;
        // console.log("Current position is ", pose.position);
        // console.log("Rotation angle is ", pose.rotation);
        // console.log("Sweep UUID is ", pose.sweep);
        // console.log("View mode is ", pose.mode);
        vm.cameraPose = pose_;
        // console.log(vm.cameraPose.position);
      });
      //  return pose_.position;
    },
    async createAStarRunner() {
      // not success
      const graph = this.sdk.Graph.createDirectedGraph();
      console.log(graph);
      console.log(graph.vertices);
      // ... setup graph vertices and edges
      const vertex = graph.vertex("a");
      console.log(vertex);
      for (const edgeIn of vertex.edgesIn) {
        console.log(
          `vertex "${edgeIn.dst.id}" has an edge coming in from a vertex "${edgeIn.src.id}"`
        );
      }
      const start = graph.vertex("start");
      const end = graph.vertex("end");
      console.log(start, end);
      const aStarRunner = this.sdk.Graph.createAStarRunner(graph, start, end);
      const result = aStarRunner.exec();
    },
    async getLabel() {
      let label = this.sdk.Label;
      console.log(label);

      let list_label = await this.sdk.Label.getData();
      console.log(list_label);
    },
    async createDeepLink() {
      const deepLink = await this.sdk.Link.createDeepLink();
      console.log(deepLink);
    },
    async createLink() {
      const link = await this.sdk.Link.createLink();
      console.log(link);
    },
    async editBillboard() {
      console.log(this.sdk.Mattertag);
      this.sdk.Mattertag.editBillboard(this.selected_Billboard, {
        label: this.label,
        description: this.description,
        media: {
          type: this.sdk.Mattertag.MediaType.PHOTO,
          src: "https://static.wikia.nocookie.net/youkoso-jitsuryoku-shijou-shugi-no-kyoushitsu-e/images/9/99/Kei_Karuizawa_LN_2nd_Year_Arc_visual.png/revision/latest?cb=20191125124817",
        },
      });
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
    async editColor() {
      let { r, g, b } = this.hexToRgb(this.color);
      console.log(r, g, b);
      this.sdk.Mattertag.editColor(this.selected_Billboard, {
        r: r/256,
        g: g/256,
        b: b/256,
      });
    },
    async subLabel() {
      // not success
      this.sdk.Label.data.subscribe({
        onAdded: function (index, item, collection) {
          console.log("Label added to the collection", index, item, collection);
        },
        onRemoved: function (index, item, collection) {
          console.log(
            "Label removed from the collection",
            index,
            item,
            collection
          );
        },
        onUpdated: function (index, item, collection) {
          console.log(
            "Label updated in place in the collection",
            index,
            item,
            collection
          );
        },
      });
    },
    async getMode() {
      let mode = await this.sdk.Mode;
      console.log("mode : ", mode);

      let CurrentViewmodeData = await this.sdk.Mode.current;
      console.log("CurrentViewmodeData : ", CurrentViewmodeData);

      let MoveToModeOptions = this.sdk.Mode.MoveToModeOptions;
      console.log("MoveToModeOptions : ", MoveToModeOptions);

      let TransitionData = this.sdk.Mode.TransitionData;
      console.log("TransitionData : ", TransitionData);
    },
    gotoPoint(item) {
      this.sdk.Mattertag.navigateToTag(
        item.sid,
        this.sdk.Mattertag.Transition.FLY
      );
    },
    onClickMap(e) {
      console.log("click map");
      console.log(e);
    },
  },
  watch: {},
};
</script>

<style>
</style>